import React from 'react';

import { ReactComponent as SavingRoboWorried } from 'assets/saving-robo-icons/worried.svg';
import { ReactComponent as logo } from 'assets/saving-robo-icons/logo.svg';

export const Logos = {
  SavingRoboWorried: SavingRoboWorried,
  logo: logo
};
